<template>
  <div class="flex flex-col">
    <div class="mb-2 lg:mb-4 text-2xl lg:text-5xl font-bold">
      {{ isApyBonus ? "+" : "" }}
      {{ value }}{{ isApyBonus ? "%" : "" }}
      <span v-if="suffix" class="text-lg lg:text-2xl uppercase ml-0 lg:ml-2">{{
        suffix
      }}</span>
    </div>
    <div class="flex gap-4">
      <div class="hidden lg:block text-black/50 font-semibold">{{ label }}</div>
      <div class="block lg:hidden text-black/50 font-semibold">
        {{ phoneLabel ?? label }}
      </div>
      <div class="hidden lg:block">
        <button
          v-if="tooltip"
          class="btn text-black/50 w-5 h-5 p-0"
          :class="[
            darkQuestionmarks
              ? 'questionmark-light'
              : 'btn-light btn-light-border',
          ]"
        >
          ?
          <tippy to="parent">
            <div class="">{{ tooltip }}</div>
          </tippy>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  value?: string | number;
  label: string;
  phoneLabel?: string;
  tooltip: string;
  suffix?: string;
  darkQuestionmarks?: boolean;
  isApyBonus?: boolean;
}

withDefaults(defineProps<Props>(), {
  darkQuestionmarks: false,
  suffix: "",
  value: 0,
  phoneLabel: undefined,
});
</script>
